import { TresciService } from "src/app/tresci.service";
import { TableColSave } from "./TableColSave";
import { deserialize, serialize } from 'class-transformer';
import { TableColSaveArray } from "./TableColSaveArray";
import { TableSortService } from "../table-sort.service";


  export class TableCol {
      DisplayedColumns:string[] = [];
      AllColumns:string[] = [];
      OtherColumns:string[];
      Key:string = "";
      user:string;
      ustawione:TableColSaveArray = new TableColSaveArray();
      constructor(allColumns:string[], key:string, user:string, tresci:TresciService){
        this.user = user;
        this.AllColumns = allColumns;
        this.Key = key;
        this.ustawione = new TableColSaveArray();
        this.wczytaj()
        this.ustawInne(false, null);
        // this.DisplayedColumns.push(this.AllColumns[0]);
      }
      public ustawInne(zapisz:boolean, tableSortService: TableSortService){
        
          
          this.ustawione.tableColSave  = this.ustawione.tableColSave.filter(tab => tab.Key != this.Key);
          this.OtherColumns = this.AllColumns.filter(name => name != '');
          this.DisplayedColumns.forEach(element => {
            this.OtherColumns= this.OtherColumns.filter(name => name != element);
          });
          this.OtherColumns.forEach(element => {
                this.ustawione.tableColSave.push(new TableColSave(this.Key, element, false, 0, this.user));
          });
          var i = 0;
          this.DisplayedColumns.forEach(element => {
            this.ustawione.tableColSave.push(new TableColSave(this.Key, element, true, i++, this.user));
          });
          if(zapisz){
            // console.log("zapisuje");
            localStorage.setItem('ustawienia_tabeli', serialize(this.ustawione)); 
          }
          

      }
      public przywroc() {
        this.ustawione = new TableColSaveArray();
        localStorage.setItem('ustawienia_tabeli', serialize([this.ustawione]));
        this.wczytaj();
        this.ustawInne(false, null);
      }
      public wczytaj(){
        // console.log("wczytuje");
        var ustawione = localStorage.getItem('ustawienia_tabeli');
        // console.log("ust", ustawione);
        this.ustawione = deserialize(TableColSaveArray, ustawione);
        // this.ustawione.tableColSave.sort((a, b) => a.kolejnosc - b.kolejnosc);
        if( this.ustawione == null){
          this.ustawione = new TableColSaveArray();
        }
        if( this.ustawione.tableColSave  == null){
          this.ustawione.tableColSave  = [];
        }
       // console.log("ust2", this.ustawione);
        var cols:TableColSave[] = [];
        this.AllColumns.forEach(element => {
          cols.push(new TableColSave(this.Key, element, true, 9999, this.user));
        });
        try {
          this.ustawione.tableColSave.forEach(element => {
            if(!element.show && element.Key == this.Key){
                cols = cols.filter(tab => tab.name != element.name);
            } else if(element.Key == this.Key){
              
              try {
                // console.log("cols", element.name);
                  cols.find(tab => tab.name == element.name).kolejnosc = element.kolejnosc;
              } catch(Exception){
                  // console.log("cols2", element.name);
              }
                
            }
          });
        } catch(e){
          // console.log("błąd");
        }
        
        cols.sort((a, b) => a.kolejnosc - b.kolejnosc);
        this.DisplayedColumns = [];
        cols.forEach(element => {
          this.DisplayedColumns.push(element.name);
        });
      }
  }